import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import ViewImg from "../../../../image/View.svg";
import SendImg from "../../../../image/Send.svg";
import DownloadIcon from "@mui/icons-material/Download";
import EmailIcon from "@mui/icons-material/Email";
import Tooltip from "@mui/material/Tooltip";
import Pagination from "../../../../components/Pagination";
import BackButton from "../../../../components/BackButton";
import api from "../../../../api/api";
import * as bootstrap from "bootstrap";
import "../../Common/form.css";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import SearchIcon from "@mui/icons-material/Search";
 
const PendingEnquiries = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [downloadingEnqId, setDownloadingEnqId] = useState(null);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [emailRecipients, setEmailRecipients] = useState("");
  const [emailLoading, setEmailLoading] = useState(false);
  const [emailError, setEmailError] = useState("");
  const [sendingEnqId, setSendingEnqId] = useState(null);
  const [showEmailSuccess, setShowEmailSuccess] = useState(false);
 
   // Filter enquiries based on search
  const filteredEnquiries = enquiries.filter((enq) =>
    enq.client_company?.toLowerCase().includes(search?.toLowerCase())
  );
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(filteredEnquiries, 10);

  const downloadQuotation = async (enq_id) => {
    setDownloadingEnqId(enq_id);
    try {
      const response = await api.get(`/quotation/download-pdf/${enq_id}`, {
        responseType: 'blob',
        validateStatus: (status) => status < 500
      });
      const blob = new Blob([response.data], { type: 'application/pdf' });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `${enq_id}_quotation.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error("Failed to download quotation:", err);
      if (err.response?.status === 401) {
        alert("Authentication required. Please login again.");
      } else if (err.response?.status === 404) {
        alert("Quotation not found.");
      } else {
        alert("Failed to download quotation. Please try again.");
      }
    } finally {
      setDownloadingEnqId(null);
    }
  };

  const sendEmail = async (enq_id) => {
    setSendingEnqId(enq_id);
    setEmailLoading(true);
    setEmailError("");
    try {
      await api.post(`/quotation/send-email/${enq_id}`, { recipients: emailRecipients });
      setShowEmailModal(false);
      setEmailRecipients("");
      setShowEmailSuccess(true);
    } catch (err) {
      console.error("Failed to send quotation email:", err);
      setEmailError("Failed to send email. Please try again.");
    } finally {
      setEmailLoading(false);
      setSendingEnqId(null);
    }
  };
 
  useEffect(() => {
    const fetchEnquiries = async () => {
      setLoading(true);
      try {
        const response = await api("/pendingEnquiries");
        // console.log("response",response);
        setEnquiries(response.data.enquiries);
        console.log(response.data.enquiries);
      } catch (error) {
        setError("Failed to fetch enquiries");
        console.error("Failed to fetch enquiries", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEnquiries();
  }, []);
  useEffect(() => {
    const tooltipTriggerList = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipTriggerList.forEach((tooltipTriggerEl) => {
      new bootstrap.Tooltip(tooltipTriggerEl);
    });
  }, [enquiries, currentPage, search]);
 
  if (error) return <p>{error.message}</p>;
 
 
  const columns = [
    { label: "Enquiry No", accessor: "enq_id" },
       {
      label: "Company Name",
      render: (row) => (
        <Tooltip
          title={row.client_company || ""}
          arrow
          placement="top"
        >
          <span
            style={{
              maxWidth: "180px",
              display: "inline-block",
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              cursor: "pointer",
            }}
          >
            {row.client_company}
          </span>
        </Tooltip>
      ),
    },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status" },
    {
      label: "Date",
      render: (row) => {
        const enquiry_created_at = row.enquiry_created_at || row.created_at;
        if (!enquiry_created_at) return "-";
        const [d, t] = enquiry_created_at.split("T");
        const [h, m] = t.split(":");
        const hr = h % 12 || 12;
        return `${d} ${hr}:${m} ${h >= 12 ? "PM" : "AM"}`;
      },
    },
{
       label: "Action",
       render: (row) => (
         <>
           {row.Status === "Enquiry Received" && (
             <Link to={`/send-quotation/${row.enq_id}`}>
               <img src={SendImg} alt="Send" />
             </Link>
           )}

            {(row.Status === "Quotation Sent" || row.Status === "Quotation Accepted") && (
              <>
                <Link to={`/view-quotation/${row.enq_id}`}>
                  <img src={ViewImg} alt="View" />
                </Link>
                {downloadingEnqId === row.enq_id ? (
                  <span className="spinner-border spinner-border-sm text-primary ms-2" role="status" aria-hidden="true"></span>
                ) : (
                  <DownloadIcon
                    style={{ cursor: "pointer", marginLeft: "8px", fontSize: 20 }}
                    onClick={() => downloadQuotation(row.enq_id)}
                  />
                )}
                <Tooltip title="Send Email">
                  <EmailIcon
                    style={{ cursor: "pointer", marginLeft: "8px", fontSize: 20, color: "#6b7280" }}
                    onClick={() => {
                      setSendingEnqId(row.enq_id);
                      setShowEmailModal(true);
                      setEmailRecipients("");
                      setEmailError("");
                    }}
                  />
                </Tooltip>
              </>
            )}
         </>
       ),
     },
  ];
  return (
    <>
      <BackButton />
 
      {/* Search + Create button */}
      <div className="d-flex align-items-center gap-2">
        <div
          className="mb-3 position-relative flex-grow-1"
          style={{ maxWidth: "100%" }}
        >
          <input
            type="search"
            className="form-control ps-5"
            placeholder="Search by Company Name..."
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
 
          <SearchIcon
            style={{
              position: "absolute",
              left: "12px",
              top: "50%",
              transform: "translateY(-50%)",
              cursor: "pointer",
              color: "#6b7280",
              width: "16px",
              height: "16px",
            }}
          />
        </div>
 
        <Link to="/create-enquiry" className="mb-3">
          <ControlPointIcon fontSize="large" />
        </Link>
      </div>
      {console.log(totalPages)}
      <Table
        columns={columns}
        data={currentItems}
        loading={loading}
        emptyMessage="No enquiries found."
        itemsPerPage={itemsPerPage}
        pagination={
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={goToPage}
            itemsPerPage={itemsPerPage}
            onItemsPerPageChange={handleItemsPerPageChange}
            totalItems={totalItems}
          />
        }
      />

      {showEmailModal && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send Quotation via Email</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEmailModal(false)}
                  disabled={emailLoading}
                ></button>
              </div>
              <div className="modal-body">
                <div className="mb-3">
                  <label htmlFor="emailRecipients" className="form-label">
                    Email Addresses (comma-separated)
                  </label>
                  <input
                    type="text"
                    className="form-control"
                    id="emailRecipients"
                    value={emailRecipients}
                    onChange={(e) => setEmailRecipients(e.target.value)}
                    placeholder="e.g., user1@example.com, user2@example.com"
                    disabled={emailLoading}
                  />
                  {emailError && (
                    <div className="text-danger mt-1">{emailError}</div>
                  )}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShowEmailModal(false)}
                  disabled={emailLoading}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => sendEmail(sendingEnqId)}
                  disabled={emailLoading || !emailRecipients.trim()}
                >
                  {emailLoading ? "Sending..." : "Send"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {showEmailSuccess && (
        <div
          className="modal fade show"
          style={{ display: "block" }}
          tabIndex="-1"
        >
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Success</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setShowEmailSuccess(false)}
                ></button>
              </div>
              <div className="modal-body">
                <p>Quotation email sent successfully!</p>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => setShowEmailSuccess(false)}
                >
                  Ok
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {(showEmailModal || showEmailSuccess) && (
        <div className="modal-backdrop fade show"></div>
      )}
    </>
  );
};
 
export default PendingEnquiries;
 